// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  AutogradeOnSubmissionRequest,
  CreateModuleVersionBody,
  GenericApiResponse,
  GenericApiResponseListCourseModule,
  GenericApiResponseListModuleLecturerResponse,
  GenericApiResponseModule,
  GenericApiResponseModuleLecturerResponse,
  GenericApiResponseWorkingModeApplyResponse,
  GenericApiResponseWorkingModeDiff,
  GetModuleByCourseAndIdParams,
  GetModuleParams,
  GetModuleVersionParams,
  GetModuleWorkingModeDiffParams,
  GetModulesByCourseParams,
  GetModulesParams,
  HTTPValidationError,
  ModuleCreateRequest,
  ModuleGlobalUpdateRequest,
  ModuleUpdateRequest,
  WorkingModeApplyRequest,
} from '../../models';

/**
 * List modules with appropriate version resolution based on context.

For students:
- Lists modules from enrolled courses (or specific course if provided)
- Resolves versions based on course enrollment
- Includes submissions and course relationships

For lecturers/admins:
- Lists all accessible modules (or modules from specific course)
- Always uses current versions
- No submissions included

If state parameter is provided, filters modules by their workflow state
(e.g. "pending_approval" to get modules pending approval).
 * @summary List Modules
 */
export const getModulesByCourse = (
  courseId: string | null,
  params?: GetModulesByCourseParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListCourseModule>> => {
  return axios.get(`/courses/${courseId}/modules`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetModulesByCourseQueryKey = (courseId: string | null, params?: GetModulesByCourseParams) => {
  return [`/courses/${courseId}/modules`, ...(params ? [params] : [])] as const;
};

export const getGetModulesByCourseQueryOptions = <
  TData = Awaited<ReturnType<typeof getModulesByCourse>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string | null,
  params?: GetModulesByCourseParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulesByCourse>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModulesByCourseQueryKey(courseId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModulesByCourse>>> = ({ signal }) =>
    getModulesByCourse(courseId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!courseId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModulesByCourse>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModulesByCourseQueryResult = NonNullable<Awaited<ReturnType<typeof getModulesByCourse>>>;
export type GetModulesByCourseQueryError = AxiosError<HTTPValidationError>;

export function useGetModulesByCourse<
  TData = Awaited<ReturnType<typeof getModulesByCourse>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string | null,
  params: undefined | GetModulesByCourseParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulesByCourse>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getModulesByCourse>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModulesByCourse<
  TData = Awaited<ReturnType<typeof getModulesByCourse>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string | null,
  params?: GetModulesByCourseParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulesByCourse>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getModulesByCourse>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModulesByCourse<
  TData = Awaited<ReturnType<typeof getModulesByCourse>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string | null,
  params?: GetModulesByCourseParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulesByCourse>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Modules
 */

export function useGetModulesByCourse<
  TData = Awaited<ReturnType<typeof getModulesByCourse>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string | null,
  params?: GetModulesByCourseParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModulesByCourse>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModulesByCourseQueryOptions(courseId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List modules with appropriate version resolution based on context.

For students:
- Lists modules from enrolled courses (or specific course if provided)
- Resolves versions based on course enrollment
- Includes submissions and course relationships

For lecturers/admins:
- Lists all accessible modules (or modules from specific course)
- Always uses current versions
- No submissions included

If state parameter is provided, filters modules by their workflow state
(e.g. "pending_approval" to get modules pending approval).
 * @summary List Modules
 */
export const getModules = (
  params?: GetModulesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListModuleLecturerResponse>> => {
  return axios.get(`/modules`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetModulesQueryKey = (params?: GetModulesParams) => {
  return [`/modules`, ...(params ? [params] : [])] as const;
};

export const getGetModulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getModules>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetModulesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModules>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModulesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModules>>> = ({ signal }) =>
    getModules(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModulesQueryResult = NonNullable<Awaited<ReturnType<typeof getModules>>>;
export type GetModulesQueryError = AxiosError<HTTPValidationError>;

export function useGetModules<TData = Awaited<ReturnType<typeof getModules>>, TError = AxiosError<HTTPValidationError>>(
  params: undefined | GetModulesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModules>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getModules>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModules<TData = Awaited<ReturnType<typeof getModules>>, TError = AxiosError<HTTPValidationError>>(
  params?: GetModulesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModules>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getModules>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModules<TData = Awaited<ReturnType<typeof getModules>>, TError = AxiosError<HTTPValidationError>>(
  params?: GetModulesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModules>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Modules
 */

export function useGetModules<TData = Awaited<ReturnType<typeof getModules>>, TError = AxiosError<HTTPValidationError>>(
  params?: GetModulesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModules>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModulesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new module

This endpoint creates a brand new module with the provided data.
 * @summary Create Module
 */
export const createModule = (
  moduleCreateRequest: ModuleCreateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.post(`/modules`, moduleCreateRequest, options);
};

export const getCreateModuleMutationOptions = <
  TData = Awaited<ReturnType<typeof createModule>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ModuleCreateRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createModule'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModule>>, { data: ModuleCreateRequest }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return createModule(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: ModuleCreateRequest },
    TContext
  >;
};

export type CreateModuleMutationResult = NonNullable<Awaited<ReturnType<typeof createModule>>>;
export type CreateModuleMutationBody = ModuleCreateRequest;
export type CreateModuleMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Create Module
 */
export const useCreateModule = <
  TData = Awaited<ReturnType<typeof createModule>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ModuleCreateRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: ModuleCreateRequest }, TContext> => {
  const mutationOptions = getCreateModuleMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get a module by ID with version resolution based on context

This endpoint returns a module with the appropriate version based on:
1. For students: The version they're currently working with
2. For lecturers: The current version (latest published, or their draft)
3. For admins: The current version

If version is explicitly specified, that version is returned regardless of context
 * @summary Get Module
 */
export const getModuleByCourseAndId = (
  courseId: string | null,
  moduleId: string,
  params?: GetModuleByCourseAndIdParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModule>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetModuleByCourseAndIdQueryKey = (
  courseId: string | null,
  moduleId: string,
  params?: GetModuleByCourseAndIdParams,
) => {
  return [`/courses/${courseId}/modules/${moduleId}`, ...(params ? [params] : [])] as const;
};

export const getGetModuleByCourseAndIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getModuleByCourseAndId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  params?: GetModuleByCourseAndIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleByCourseAndId>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModuleByCourseAndIdQueryKey(courseId, moduleId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModuleByCourseAndId>>> = ({ signal }) =>
    getModuleByCourseAndId(courseId, moduleId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(courseId && moduleId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModuleByCourseAndId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModuleByCourseAndIdQueryResult = NonNullable<Awaited<ReturnType<typeof getModuleByCourseAndId>>>;
export type GetModuleByCourseAndIdQueryError = AxiosError<HTTPValidationError>;

export function useGetModuleByCourseAndId<
  TData = Awaited<ReturnType<typeof getModuleByCourseAndId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  params: undefined | GetModuleByCourseAndIdParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleByCourseAndId>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getModuleByCourseAndId>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleByCourseAndId<
  TData = Awaited<ReturnType<typeof getModuleByCourseAndId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  params?: GetModuleByCourseAndIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleByCourseAndId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getModuleByCourseAndId>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleByCourseAndId<
  TData = Awaited<ReturnType<typeof getModuleByCourseAndId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  params?: GetModuleByCourseAndIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleByCourseAndId>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Module
 */

export function useGetModuleByCourseAndId<
  TData = Awaited<ReturnType<typeof getModuleByCourseAndId>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string | null,
  moduleId: string,
  params?: GetModuleByCourseAndIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleByCourseAndId>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModuleByCourseAndIdQueryOptions(courseId, moduleId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a module by ID with version resolution based on context

This endpoint returns a module with the appropriate version based on:
1. For students: The version they're currently working with
2. For lecturers: The current version (latest published, or their draft)
3. For admins: The current version

If version is explicitly specified, that version is returned regardless of context
 * @summary Get Module
 */
export const getModuleVersion = (
  moduleId: string,
  version: string | null,
  params?: GetModuleVersionParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.get(`/modules/${moduleId}/versions/${version}`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetModuleVersionQueryKey = (
  moduleId: string,
  version: string | null,
  params?: GetModuleVersionParams,
) => {
  return [`/modules/${moduleId}/versions/${version}`, ...(params ? [params] : [])] as const;
};

export const getGetModuleVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string | null,
  params?: GetModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModuleVersionQueryKey(moduleId, version, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModuleVersion>>> = ({ signal }) =>
    getModuleVersion(moduleId, version, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(moduleId && version), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModuleVersion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModuleVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getModuleVersion>>>;
export type GetModuleVersionQueryError = AxiosError<HTTPValidationError>;

export function useGetModuleVersion<
  TData = Awaited<ReturnType<typeof getModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string | null,
  params: undefined | GetModuleVersionParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleVersion>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getModuleVersion>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleVersion<
  TData = Awaited<ReturnType<typeof getModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string | null,
  params?: GetModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleVersion>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getModuleVersion>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleVersion<
  TData = Awaited<ReturnType<typeof getModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string | null,
  params?: GetModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Module
 */

export function useGetModuleVersion<
  TData = Awaited<ReturnType<typeof getModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string | null,
  params?: GetModuleVersionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleVersion>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModuleVersionQueryOptions(moduleId, version, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete a specific version of a module

This endpoint deletes a specific version of a module.
The module will still exist, but the specified version will be removed.
 * @summary Delete Module Version
 */
export const deleteModuleVersion = (
  moduleId: string,
  version: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.delete(`/modules/${moduleId}/versions/${version}`, options);
};

export const getDeleteModuleVersionMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteModuleVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteModuleVersion>>,
    { moduleId: string; version: string }
  > = (props) => {
    const { moduleId, version } = props ?? {};

    return deleteModuleVersion(moduleId, version, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string },
    TContext
  >;
};

export type DeleteModuleVersionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteModuleVersion>>>;

export type DeleteModuleVersionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Module Version
 */
export const useDeleteModuleVersion = <
  TData = Awaited<ReturnType<typeof deleteModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string; version: string }, TContext> => {
  const mutationOptions = getDeleteModuleVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get a module by ID with version resolution based on context

This endpoint returns a module with the appropriate version based on:
1. For students: The version they're currently working with
2. For lecturers: The current version (latest published, or their draft)
3. For admins: The current version

If version is explicitly specified, that version is returned regardless of context
 * @summary Get Module
 */
export const getModule = (
  moduleId: string,
  params?: GetModuleParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.get(`/modules/${moduleId}`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetModuleQueryKey = (moduleId: string, params?: GetModuleParams) => {
  return [`/modules/${moduleId}`, ...(params ? [params] : [])] as const;
};

export const getGetModuleQueryOptions = <
  TData = Awaited<ReturnType<typeof getModule>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  params?: GetModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModuleQueryKey(moduleId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModule>>> = ({ signal }) =>
    getModule(moduleId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!moduleId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModule>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModuleQueryResult = NonNullable<Awaited<ReturnType<typeof getModule>>>;
export type GetModuleQueryError = AxiosError<HTTPValidationError>;

export function useGetModule<TData = Awaited<ReturnType<typeof getModule>>, TError = AxiosError<HTTPValidationError>>(
  moduleId: string,
  params: undefined | GetModuleParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModule>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getModule>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModule<TData = Awaited<ReturnType<typeof getModule>>, TError = AxiosError<HTTPValidationError>>(
  moduleId: string,
  params?: GetModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModule>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getModule>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModule<TData = Awaited<ReturnType<typeof getModule>>, TError = AxiosError<HTTPValidationError>>(
  moduleId: string,
  params?: GetModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Module
 */

export function useGetModule<TData = Awaited<ReturnType<typeof getModule>>, TError = AxiosError<HTTPValidationError>>(
  moduleId: string,
  params?: GetModuleParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModule>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModuleQueryOptions(moduleId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a module across all its versions

This admin-only endpoint allows updating properties that should be
consistent across all versions of a module, such as the title.

This is useful for correcting titles and other global properties
that should be consistent across all versions.
 * @summary Update Module Across Versions
 */
export const updateModuleAcrossVersions = (
  moduleId: string,
  moduleGlobalUpdateRequest: ModuleGlobalUpdateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.put(`/modules/${moduleId}`, moduleGlobalUpdateRequest, options);
};

export const getUpdateModuleAcrossVersionsMutationOptions = <
  TData = Awaited<ReturnType<typeof updateModuleAcrossVersions>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; data: ModuleGlobalUpdateRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateModuleAcrossVersions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModuleAcrossVersions>>,
    { moduleId: string; data: ModuleGlobalUpdateRequest }
  > = (props) => {
    const { moduleId, data } = props ?? {};

    return updateModuleAcrossVersions(moduleId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; data: ModuleGlobalUpdateRequest },
    TContext
  >;
};

export type UpdateModuleAcrossVersionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateModuleAcrossVersions>>
>;
export type UpdateModuleAcrossVersionsMutationBody = ModuleGlobalUpdateRequest;
export type UpdateModuleAcrossVersionsMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Module Across Versions
 */
export const useUpdateModuleAcrossVersions = <
  TData = Awaited<ReturnType<typeof updateModuleAcrossVersions>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; data: ModuleGlobalUpdateRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string; data: ModuleGlobalUpdateRequest }, TContext> => {
  const mutationOptions = getUpdateModuleAcrossVersionsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete an entire module and all its versions.

This endpoint deletes the entire module, including:
- All versions of the module
- All resources (tasks, images) for all versions
- Course references (since the module is being completely removed)
 * @summary Delete Module
 */
export const deleteModule = (
  moduleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.delete(`/modules/${moduleId}`, options);
};

export const getDeleteModuleMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteModule>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteModule'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteModule>>, { moduleId: string }> = (props) => {
    const { moduleId } = props ?? {};

    return deleteModule(moduleId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { moduleId: string }, TContext>;
};

export type DeleteModuleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteModule>>>;

export type DeleteModuleMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Module
 */
export const useDeleteModule = <
  TData = Awaited<ReturnType<typeof deleteModule>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string }, TContext> => {
  const mutationOptions = getDeleteModuleMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Update a specific version of a module.

Supports updating mandates with optional propagation to all course-modules.
When propagate_mandates=True, all course-modules using this module will
have their mandates updated to match the module defaults.
 * @summary Update Module
 */
export const updateModuleVersion = (
  moduleId: string,
  moduleVersion: string,
  moduleUpdateRequest: ModuleUpdateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.put(`/modules/${moduleId}/versions/${moduleVersion}`, moduleUpdateRequest, options);
};

export const getUpdateModuleVersionMutationOptions = <
  TData = Awaited<ReturnType<typeof updateModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; data: ModuleUpdateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateModuleVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateModuleVersion>>,
    { moduleId: string; moduleVersion: string; data: ModuleUpdateRequest }
  > = (props) => {
    const { moduleId, moduleVersion, data } = props ?? {};

    return updateModuleVersion(moduleId, moduleVersion, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; data: ModuleUpdateRequest },
    TContext
  >;
};

export type UpdateModuleVersionMutationResult = NonNullable<Awaited<ReturnType<typeof updateModuleVersion>>>;
export type UpdateModuleVersionMutationBody = ModuleUpdateRequest;
export type UpdateModuleVersionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Module
 */
export const useUpdateModuleVersion = <
  TData = Awaited<ReturnType<typeof updateModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; data: ModuleUpdateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; moduleVersion: string; data: ModuleUpdateRequest },
  TContext
> => {
  const mutationOptions = getUpdateModuleVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Set the module-wide autograde-on-submission flag.

No version is taken in the path by design: autograde-on-submission is operational
grading config applied module-wide (written to every version), editable by the owner
in any workflow state (gated by ModuleActions.UPDATE_GRADING_SETTINGS, not UPDATE_CONTENT).
 * @summary Set Module Autograde On Submission
 */
export const setModuleAutogradeOnSubmission = (
  moduleId: string,
  autogradeOnSubmissionRequest: AutogradeOnSubmissionRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.put(`/modules/${moduleId}/autograde-on-submission`, autogradeOnSubmissionRequest, options);
};

export const getSetModuleAutogradeOnSubmissionMutationOptions = <
  TData = Awaited<ReturnType<typeof setModuleAutogradeOnSubmission>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; data: AutogradeOnSubmissionRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['setModuleAutogradeOnSubmission'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setModuleAutogradeOnSubmission>>,
    { moduleId: string; data: AutogradeOnSubmissionRequest }
  > = (props) => {
    const { moduleId, data } = props ?? {};

    return setModuleAutogradeOnSubmission(moduleId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; data: AutogradeOnSubmissionRequest },
    TContext
  >;
};

export type SetModuleAutogradeOnSubmissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof setModuleAutogradeOnSubmission>>
>;
export type SetModuleAutogradeOnSubmissionMutationBody = AutogradeOnSubmissionRequest;
export type SetModuleAutogradeOnSubmissionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Set Module Autograde On Submission
 */
export const useSetModuleAutogradeOnSubmission = <
  TData = Awaited<ReturnType<typeof setModuleAutogradeOnSubmission>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; data: AutogradeOnSubmissionRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string; data: AutogradeOnSubmissionRequest }, TContext> => {
  const mutationOptions = getSetModuleAutogradeOnSubmissionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Create a new version of an existing module

This endpoint creates a new draft version of an existing module,
preserving all content but incrementing the version number.
The new version will become the editing target, while the previous
version remains accessible for students who are already using it.

If source_version is provided, the new version will be based on that specific
version of the module. Otherwise, it will use the current version.

Note: Only published or draft versions can be used to create a new version.
 * @summary Create Module Version
 */
export const createModuleVersion = (
  moduleId: string,
  createModuleVersionBody: CreateModuleVersionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.post(`/modules/${moduleId}/versions`, createModuleVersionBody, options);
};

export const getCreateModuleVersionMutationOptions = <
  TData = Awaited<ReturnType<typeof createModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; data: CreateModuleVersionBody }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createModuleVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModuleVersion>>,
    { moduleId: string; data: CreateModuleVersionBody }
  > = (props) => {
    const { moduleId, data } = props ?? {};

    return createModuleVersion(moduleId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; data: CreateModuleVersionBody },
    TContext
  >;
};

export type CreateModuleVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createModuleVersion>>>;
export type CreateModuleVersionMutationBody = CreateModuleVersionBody;
export type CreateModuleVersionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Create Module Version
 */
export const useCreateModuleVersion = <
  TData = Awaited<ReturnType<typeof createModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; data: CreateModuleVersionBody }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string; data: CreateModuleVersionBody }, TContext> => {
  const mutationOptions = getCreateModuleVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Describe changes required to move a draft module version toward a working mode.
 * @summary Get Module Working Mode Diff
 */
export const getModuleWorkingModeDiff = (
  moduleId: string,
  version: string,
  params: GetModuleWorkingModeDiffParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseWorkingModeDiff>> => {
  return axios.get(`/modules/${moduleId}/versions/${version}/working-mode/diff`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetModuleWorkingModeDiffQueryKey = (
  moduleId: string,
  version: string,
  params: GetModuleWorkingModeDiffParams,
) => {
  return [`/modules/${moduleId}/versions/${version}/working-mode/diff`, ...(params ? [params] : [])] as const;
};

export const getGetModuleWorkingModeDiffQueryOptions = <
  TData = Awaited<ReturnType<typeof getModuleWorkingModeDiff>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  params: GetModuleWorkingModeDiffParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleWorkingModeDiff>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModuleWorkingModeDiffQueryKey(moduleId, version, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModuleWorkingModeDiff>>> = ({ signal }) =>
    getModuleWorkingModeDiff(moduleId, version, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(moduleId && version), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModuleWorkingModeDiff>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModuleWorkingModeDiffQueryResult = NonNullable<Awaited<ReturnType<typeof getModuleWorkingModeDiff>>>;
export type GetModuleWorkingModeDiffQueryError = AxiosError<HTTPValidationError>;

export function useGetModuleWorkingModeDiff<
  TData = Awaited<ReturnType<typeof getModuleWorkingModeDiff>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  params: GetModuleWorkingModeDiffParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleWorkingModeDiff>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getModuleWorkingModeDiff>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleWorkingModeDiff<
  TData = Awaited<ReturnType<typeof getModuleWorkingModeDiff>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  params: GetModuleWorkingModeDiffParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleWorkingModeDiff>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getModuleWorkingModeDiff>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleWorkingModeDiff<
  TData = Awaited<ReturnType<typeof getModuleWorkingModeDiff>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  params: GetModuleWorkingModeDiffParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleWorkingModeDiff>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Module Working Mode Diff
 */

export function useGetModuleWorkingModeDiff<
  TData = Awaited<ReturnType<typeof getModuleWorkingModeDiff>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  params: GetModuleWorkingModeDiffParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleWorkingModeDiff>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModuleWorkingModeDiffQueryOptions(moduleId, version, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Apply a working mode to a draft module version.
 * @summary Apply Module Working Mode
 */
export const applyModuleWorkingMode = (
  moduleId: string,
  version: string,
  workingModeApplyRequest: WorkingModeApplyRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseWorkingModeApplyResponse>> => {
  return axios.post(`/modules/${moduleId}/versions/${version}/working-mode/apply`, workingModeApplyRequest, options);
};

export const getApplyModuleWorkingModeMutationOptions = <
  TData = Awaited<ReturnType<typeof applyModuleWorkingMode>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: WorkingModeApplyRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['applyModuleWorkingMode'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyModuleWorkingMode>>,
    { moduleId: string; version: string; data: WorkingModeApplyRequest }
  > = (props) => {
    const { moduleId, version, data } = props ?? {};

    return applyModuleWorkingMode(moduleId, version, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: WorkingModeApplyRequest },
    TContext
  >;
};

export type ApplyModuleWorkingModeMutationResult = NonNullable<Awaited<ReturnType<typeof applyModuleWorkingMode>>>;
export type ApplyModuleWorkingModeMutationBody = WorkingModeApplyRequest;
export type ApplyModuleWorkingModeMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Apply Module Working Mode
 */
export const useApplyModuleWorkingMode = <
  TData = Awaited<ReturnType<typeof applyModuleWorkingMode>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: WorkingModeApplyRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; data: WorkingModeApplyRequest },
  TContext
> => {
  const mutationOptions = getApplyModuleWorkingModeMutationOptions(options);

  return useMutation(mutationOptions);
};
